import { ButtonHTMLAttributes } from 'react'
import * as React from 'react'
import styled, { css } from 'styled-components'

interface IProps extends ButtonHTMLAttributes<HTMLDivElement> {
  direction?: 'row' | 'col'
  className?: string
}

const MoreDropdownBtn: React.FC<IProps> = ({
  className,
  direction = 'col',
  ...props
}) => {
  return (
    <StyledWrapper className={className} direction={direction} {...props}>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </StyledWrapper>
  )
}

export default MoreDropdownBtn

const StyledWrapper = styled.div<{
  direction: 'row' | 'col'
}>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  padding: 0;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  cursor: pointer;
  .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #ccc;
  }
  &:hover {
    background-color: #f5f5f5;
  }
  &[data-open='true'] {
    background-color: #f5f5f5;
  }
  ${({ direction }) =>
    direction === 'row' &&
    css`
      flex-direction: row;
    `}
`
